
import AppData from "./const/app_data";
import LoaclStorage from "../../manager/local_storage";
import GameUtil from "../../utility/game_util";
import PromiseUtility from "../../utility/promiseUtility";
import UserDataManager from "../../manager/user_manager";
import Utility from "../../utility/utility";
import ModuleManager from "../../framework/core/module_manager";
import { IShareData } from "../../manager/share_manager";
import { friend_utils } from "../hall/module/friend/friend_utils";
import SdkStorage from "../../sdk/SdkStorage";
import AppController from "../../sdk/app_controller";
import LogManager from "../../manager/log_manager";


export interface ITableCommonData {
    tableType?: number
    goldFildId?: number
    /**
     * 是否为俱乐部
     */
    isClubTable?: boolean,

    //非字符串，为结构体
    roomRuleData?: any
    //房间规则
    roomRule?: any
    isGoldTable?: boolean
    isGoldSettle?: boolean
    isGoldUnlimited?: boolean
    isGoldMatchingTable?: boolean
    isGoldFriendTable?: boolean
    qualifyId?: number
    autoLeaveWhenGameEnd?: boolean
}

export interface IUserData {
    id?: number
    idShow?: string
    name?: string
    avatar?: string
    avatarSprite?: cc.SpriteFrame

    gender?: number
    male?: boolean
    ip?: string
    adress?: string


    gold?: number            //当前运营系统获取到的货币
    gameTableGold?: number  //在游戏中的货币
    vipLevel?: number

    winCount?: number
    lostCount?: number
    tieCount?: number
    score?: number

    breakRate?: number
    sessionId?: string
    isSmAuth?: boolean

    inviteCode?: string
    parentId?: number

    mobile?: string
    lastUpdateTime?: number

    haveCofferPassport?: boolean

    getAvatarSuccess?: boolean

    matchingChannelId?: number

    clientLogInfo?: string

    expCurrent?: number;
    expNext?: number;
    userLevel?: number;
    friend?: boolean

    passportThridType?: number;//登录方式 0游客 2Facebook 3line 5mobile
    vipConfigList?: any[];

    //个性化code
    plizedCardIcon?: string;
    plizedHeadFrame?: string;
    plizedHeadImg?: string;

}


export class RoomInfo {
    RoomID?: number
    UserID?: number
    Password?: string
    ServerHost?: string
    // PlayRule?: string
    PlayRuleData?: any
    ServerPort?: number
    SeatID?: number
    RoundCount?: number
    RoomType: number = 0
    GoldFieldID: number
    HallID: number
    MatchAwardRank: number
    MatchID: number
    Token: number
    wsport: number
    RoomHisID: number
    RoomIx: Number
    constructor() { }
}


//玩家头像信息
export class PlayerIconData {
    iconIndex: number = 0;
    iconName: string;
    isMale: boolean = false;
    iconRes: cc.SpriteFrame = null;
}

//大厅显示游戏数据
export interface HallShowGameData {
    gameId?: string,
    openLevel?: number
    openChip: boolean,
    openGold: boolean,
}


// export enum AppRemoteConfigType {
//     //获取玩家间可赠送次数
//     handselCnt = "",
//     //获取玩家间赠送额度
//     handselNum ?: number,   
//     //玩家可转账等级
//     transferLev ?: number,   
//     //获取玩家每日最小转账额度
//     transferMinNum ?: number,   

// }


export default class ModelData {

    public static instance: ModelData = new ModelData();

    rule: string

    roleData: IUserData = { gold: 0, score: 0, winCount: 0, lostCount: 0, tieCount: 0, vipLevel: -1 }//没有默认值直接取是undifined

    showChipCurrency: boolean = true
    showGoldCurrency: boolean = false

    gameDataShow: HallShowGameData[]

    shareModuleData: IShareData[]

    //是否需要绑定了社交账号
    needBindSocialAccount : boolean = false

    //游客登录
    loginWithVisitors : boolean = false

    userId: number

    //密码
    password: string

    userToken: string

    //注册时间
    regTime: number = 0

    roomInfo: RoomInfo
    // 0 正常登录 1 登录后创建房间 2 登录后加入房间
    loginState: number = 0

    roomId: number

    goldFieldID: number

    clubId : number = 0;

    tableCommonData: ITableCommonData = {}

    wxLoginRequestData = null

    needAutoShowJiSaiJiangLi: boolean = false

    playerIconConfig: { [key: string]: PlayerIconData } = {}

    appRemoteConfig: any

    isAppScore: boolean = false

    isActivationAward: boolean = false

    lastGetChannelPlatformRefTime = 0

    lastGetAppRemoteConfigTime = 0



    //刷新角色信息
    refreshRoleData(data) {
        if (data.gameUserId && data.gameUserId != ModelData.instance.roleData.id) {
            return
        }
        ModelData.instance.roleData.name = data.nickname          //昵称
        ModelData.instance.roleData.avatar = data.headImg        //头像
        ModelData.instance.roleData.gender = data.gender         //性别
        ModelData.instance.roleData.male = data.gender == 1//性别

        if (data.userLevel || data.userGameConfig) {
            ModelData.instance.roleData.expCurrent = data.expCurrent
            ModelData.instance.roleData.expNext = data.expNext
            ModelData.instance.roleData.userLevel = data.userLevel
            ModelData.instance.roleData.mobile = data.mobile //手机号
            ModelData.instance.roleData.inviteCode = data.inviteCode //邀请码
            ModelData.instance.roleData.matchingChannelId = data.independent ? data.channelId : undefined
            ModelData.instance.roleData.haveCofferPassport = data.haveCofferPassport
            ModelData.instance.roleData.lastUpdateTime = Date.now()
            ModelData.instance.roleData.friend = data.friend
            ModelData.instance.setRoleParentId(data.parentId) //上级ID
            ModelData.instance.roleData.plizedCardIcon = data.plizedCardIcon //牌背
            ModelData.instance.roleData.plizedHeadFrame = data.plizedHeadFrame //头像框
            ModelData.instance.roleData.plizedHeadImg = data.plizedHeadImg //头像框
        }
        
    }

    setRoleData(userId, password) {
        let lastId = ModelData.instance.roleData.id
        ModelData.instance.roleData.id = userId
        ModelData.instance.userId = userId
        ModelData.instance.password = password
        ModelData.instance.userToken = password
        SdkStorage.setLoginToken(password);
        LoaclStorage.setStorageString("loginUserPassword", password)
        if (lastId == userId) {
            return
        }
        LoaclStorage.setStorageNumber("loginUserID", userId)
        LoaclStorage.setNumber("LastLoginID", userId)
        AppController.instance.setBuglyUserid(userId.toString())
        LogManager.instance.setUid(userId)
        LoaclStorage.setSuffix(AppData.userConnectEnvi, userId)
    }

    setRoleParentId(parentId) {
        ModelData.instance.roleData.parentId = parentId
    }


    getGameDataShow(gameId): HallShowGameData {
        return this.gameDataShow.find(item => item.gameId == gameId);
    }

    setQulifyId(qualifyId) {
        ModelData.instance.tableCommonData.qualifyId = qualifyId
    }

    //加入房间数据转本地
    initRoomData(protoData: any) {
        this.roomInfo = new RoomInfo()
        this.roomInfo.UserID = Number(this.roleData.id)
        this.roomInfo.GoldFieldID = protoData.GoldFieldID
        this.roomInfo.Password = protoData.Password
        this.roomInfo.HallID = protoData.HallID
        this.roomInfo.MatchAwardRank = protoData.MatchAwardRank
        this.roomInfo.MatchID = protoData.MatchID
        this.roomInfo.RoomID = protoData.RoomID
        this.roomInfo.RoomType = protoData.RoomType
        this.roomInfo.RoundCount = protoData.RoundCount
        if (protoData.Rule) {
            this.roomInfo.PlayRuleData = JSON.parse(protoData.Rule)

        }


        this.roomInfo.SeatID = protoData.SeatID
        this.roomInfo.ServerHost = protoData.ServerHost
        this.roomInfo.ServerPort = protoData.ServerPort
        this.roomInfo.Token = protoData.Token
        this.roomInfo.ServerHost = protoData.ServerHost
        this.roomInfo.wsport = protoData.wsport
        this.roomInfo.RoomHisID = protoData.RoomHisID
        this.roomInfo.RoomIx = protoData.RoomIx
    }

    //初始化APP全局配置数据
    initAppConfigData(data: any) {
        this.appRemoteConfig = data
    }

    cacheIconConfig(data: any) {
        let iconDic: { [key: string]: any } = {};
        for (let key in data) {
            let iconData = new PlayerIconData();
            iconData.iconName = key;
            iconData.isMale = key.startsWith("2");
            iconData.iconRes = data[key].iconRes
            iconData.iconIndex = parseInt(key)
            iconDic[key] = iconData;
        }
        this.playerIconConfig = iconDic;
    }
    getPlayerIconByName(iconName: string): cc.SpriteFrame {
        if (this.playerIconConfig[iconName]) {
            return this.playerIconConfig[iconName].iconRes;
        } else {
            cc.warn("找不到头像资源:" + iconName)
            //找不到的情况给第一个头像用作头像,以防死循环
            for (const key in this.playerIconConfig) {
                if (this.playerIconConfig.hasOwnProperty(key)) {
                    const element = this.playerIconConfig[key];
                    return element.iconRes;
                }
            }
        }
        return null;
    }
    getPlayerIcons() {
        let arrMale: PlayerIconData[] = [];
        let arrFemale: PlayerIconData[] = [];
        for (let key in this.playerIconConfig) {
            let data = this.playerIconConfig[key];
            if (data.isMale) {
                arrMale.push(data);
            } else {
                arrFemale.push(data);
            }
        }
        function sortData(a: PlayerIconData, b: PlayerIconData) {
            if (a.iconIndex > b.iconIndex) {
                return 1;
            }
            if (a.iconIndex < b.iconIndex) {
                return -1;
            }
            return 0;
        }
        arrMale.sort(sortData);
        arrFemale.sort(sortData);
        return [arrMale, arrFemale];
    }

    reset() {
        this.gameDataShow = null
        this.roleData.id = 0
        this.userId = 0
        this.appRemoteConfig = null
        this.clubId = 0
        this.loginWithVisitors = false
    }


    getGameList(callback?) {
        let self = ModelData.instance
        if (self.gameDataShow != null && new Date().getTime() - self.lastGetChannelPlatformRefTime < 600000) {
            callback && callback()
            return
        }
        let requestData: IHttpRequestData = {
            baseUrl: "game/channelPlatformRef?",
            useCache: self.gameDataShow != null,
            cacheKey: "game/channelPlatformRef?id=" + self.roleData.id,
        }
        if (CC_PREVIEW) {
            requestData.useCacheCallbackBreakRequest = false
        }
        let limiLevel = self.regTime > 1585018800000 || AppData.testMode
        // let limiLevel = self.regTime > 1553011200000
        GameUtil.apiHttpGet(requestData, function (retData) {
            let data = retData.data
            self.gameDataShow = []
            for (let i = 0; i < data.length; i++) {
                let gameData: HallShowGameData = { "gameId": data[i].gameId, "openChip": false, "openGold": true, "openLevel": (limiLevel && data[i].userLevel) ? data[i].userLevel : 1 }
                self.gameDataShow.push(gameData)
            }
            callback && callback()
            callback = null
            if (!retData.isResponseCache) {
                self.lastGetChannelPlatformRefTime = new Date().getTime();
            }
        }, function (err) {
            cc.log(err)
            ModuleManager.instance.hideModule("NetPrompt")
            !AppData.showHall && Utility.reportConversionEvent("login_requiredata_request_error")
        })
    }
    
    getRoleInfoData(callback) {
        UserDataManager.getData(ModelData.instance.roleData.id, (data) => {
            if (data.passportThridType != null) {
                ModelData.instance.loginWithVisitors = data.passportThridType == 0
            }
            
            callback && callback()
        })
    }

    getAccountLoginBindData(callback) {
        let self = ModelData.instance
        let needBindSocialAccount = LoaclStorage.getString("_userLoginVisitNeedBindSocialAccount?" + self.roleData.id)
        if (needBindSocialAccount != null && needBindSocialAccount == "hasBind") {
            self.needBindSocialAccount = false
            callback && callback()
            return
        }
        let requestData: IHttpRequestData = {
            baseUrl: "user/passport/getBindPassportInfo?",
            useCache: true,
            cacheKey: "user/passport/getBindPassportInfo?id=" + self.roleData.id,
        }
        GameUtil.apiHttpGet(requestData, function (retData) {
            let data = retData.data
            if (data.visitLogin && (data.facebook || data.line)) {
                self.needBindSocialAccount = true
            } else {
                self.needBindSocialAccount = false
                LoaclStorage.setString("_userLoginVisitNeedBindSocialAccount?" + self.roleData.id, "hasBind")
            }
            callback && callback()
            callback = null
        }, function (err) {
            ModuleManager.instance.hideModule("NetPrompt")
            cc.log(err)
            self.needBindSocialAccount = false
            callback && callback()
            callback = null
   
        })
    }

    //为了避免进入大厅的界面闪动，先获取必要的数据
    getRequiredData(onFinish) {
        !AppData.showHall && Utility.reportConversionEvent("login_requiredata_request")
        ModelData.instance.httpGetAppRemoteConfigData()
        friend_utils.init();
        PromiseUtility.all([this.getGameList, this.getRoleInfoData, this.getAccountLoginBindData]).then(onFinish)
    }

    //获取APP全局配置
    httpGetAppRemoteConfigData(callback?, getNewData?: boolean, showNetPrompt?: boolean) {
        if (!getNewData && this.appRemoteConfig != null && new Date().getTime() - this.lastGetAppRemoteConfigTime < 600000) {
            callback && callback(this.appRemoteConfig)
            return
        }

        let requestData: IHttpRequestData = {
            baseUrl: "commons/getSysConfig?",
            showNetPrompt: showNetPrompt,
        }
        GameUtil.apiHttpGet(requestData, (respone) => {
            ModelData.instance.lastGetAppRemoteConfigTime = new Date().getTime()
            ModelData.instance.initAppConfigData(respone.data)
            callback && callback(ModelData.instance.appRemoteConfig)
        })
    }

    getAppRemoteConfig(key, defautValue?) {
        return (this.appRemoteConfig && this.appRemoteConfig[key]) || defautValue
    }

    setTableCommonData(ruleData) {
        this.tableCommonData.roomRuleData = ruleData
        this.tableCommonData.isClubTable = ruleData.pub_AccountType == 200;
        if (this.tableCommonData.isClubTable && this.clubId == 0) {
            this.clubId = LoaclStorage.getNumber("__lastEnterClubId", 0)
        }
    }


}